// POD-03's native ink value must also follow colour changes in cart editing.
const inkFields = Object.freeze({
  "layer-861002": "layer-944000",
  "layer-862002": "layer-944282",
  "layer-863002": "layer-944564",
  "layer-864002": "layer-944846",
  "layer-865002": "layer-945128",
  "layer-866002": "layer-945410",
  "layer-867002": "layer-945692",
  "layer-868002": "layer-945974",
  "layer-869002": "layer-946256",
  "layer-870002": "layer-946538"
});
const darkBackgrounds = new Set(['#f4f1e9', '#e8a5b9', '#cfa3eb']);
let frame = null;
let listeners = null;
const observer = new MutationObserver(schedule);
function schedule() {
  if (frame !== null) return;
  frame = requestAnimationFrame(() => { frame = null; sync(); });
}
function sync() {
  for (const form of document.querySelectorAll('#tee-artwork-form')) {
    for (const [backgroundId, inkId] of Object.entries(inkFields)) {
      const background = form.querySelector(`[id="tee-field--${backgroundId}"]`);
      const ink = form.querySelector(`[id="tee-field--${inkId}"]`);
      if (!background || !ink) continue;
      ink.setAttribute('aria-hidden', 'true');
      ink.hidden = true;
      ink.style.setProperty('display', 'none', 'important');
      const selected = background.querySelector('.tee-clipart.active input, input:checked');
      if (!(selected instanceof HTMLInputElement)) continue;
      const wanted = darkBackgrounds.has(selected.value.toLowerCase()) ? '#161616' : '#ffffff';
      const current = ink.querySelector('.tee-radio.active input, input:checked');
      if (current instanceof HTMLInputElement && current.value.toLowerCase() === wanted) continue;
      const radio = Array.from(ink.querySelectorAll('input[type="radio"]')).find(e => e.value.toLowerCase() === wanted);
      const label = Array.from(ink.querySelectorAll('label[for]')).find(e => e.htmlFor === radio?.id);
      // Commit via the native Vue input, so cart and generated previews agree.
      if (label instanceof HTMLLabelElement) label.click();
    }
  }
}
function start() {
  if (listeners && !listeners.signal.aborted) return;
  listeners = new AbortController();
  for (const event of ['click', 'input', 'change']) document.addEventListener(event, schedule, {signal: listeners.signal});
  observer.observe(document.body, {childList: true, subtree: true});
  schedule();
}
function stop() {
  listeners?.abort(); observer.disconnect();
  if (frame !== null) cancelAnimationFrame(frame);
  frame = null;
}
start();
window.addEventListener('pagehide', stop);
window.addEventListener('pageshow', start);
